"use strict";

exports.__esModule = true;
exports.AppSidebar = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _AppSidebar = require("./AppSidebar.legacy");
var _AppSidebar2 = require("./AppSidebar.modern");
// Flag-gated UI: `AppSidebar.legacy` is the component as it is on master,
// `AppSidebar.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var AppSidebar = exports.AppSidebar = (0, _uiSwitch.uiSwitch)(_AppSidebar.AppSidebar, _AppSidebar2.AppSidebar, "AppSidebar");